import React from 'react';
import {
  Modal,
  Button,
  FormGroup,
  FormControl,
  HelpBlock,
  ControlLabel,
  Grid,
  Row,
  Col,
  Checkbox,
  Glyphicon,
  InputGroup,
  OverlayTrigger,
  Popover,
  Alert,
  Tooltip,
} from 'react-bootstrap';
import { getErrorForItem } from './LinkPolicyScreen';
import { connect } from 'react-redux';
import { accountOperations } from 'insured-ui-state-mgmt/dist/ducks/account';
import { userDetailsSchema } from 'insured-ui-state-mgmt/dist/util/yup_validations/registration/schema';
import Loading from '../registrationScreens/Loading';
import parse from 'html-react-parser';
import MaskedInput from 'react-maskedinput';
import { ErrorMessage } from './Errors';
import Datetime from 'react-datetime';
let ua = window.navigator.userAgent;

class RegisterUserInfoScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
      showPassword: false,
      isLoading: false,
      phoneWithDashes: '',
      data: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        password: '',
        agreeToTerms: false,
        postalCode: '',
        id: 'wbmi1975432018',
        policyNumber: props.policyInfo.policyNumber,
        dateOfBirth: '',
        customerOrBillingNumber: '',
      },
      day: '',
      month: '',
      year: '',
      errors: [],
    };
    this.notificationSystem = React.createRef();
  }

  componentDidMount() {
    if (!this.props.policyInfo.hasOwnProperty('policyNumber') && !this.props.policyInfo.hasOwnProperty('policyType')) {
      this.props.transition.router.stateService.go('registrationScreen1');
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!Object.is(this.props.response, prevProps.response)) {
      if (this.props.response.code === 0) {
        console.log('Navigating to screen 2');
        this.setState({ isLoading: false }, () => {
          this.showNextScreen();
        });
      }

      if (this.props.response.code) {
        this.setState({ isLoading: false }, () => {});
      }
    }

    if (
      prevState.day !== this.state.day ||
      prevState.month !== this.state.month ||
      prevState.year !== this.state.year
    ) {
      this.formatDate();
    }
  }

  renderCustomerOrBillingTooltip = (
    <Tooltip
      id="customerOrBilling-trigger-hover-focus"
      title=""
    >
      Input a 10-digit customer number (e.g., 1000099999) or 12-digit billing number (e.g., 100009999999)
    </Tooltip>
  );

  showNextScreen = () => {
    this.props.transition.router.stateService.go('registrationScreen3', { response: this.props.response });
  };

  handleClose = () => {
    this.setState(
      {
        show: false,
      },
      () => {
        this.props.transition.router.stateService.go('registrationScreen1');
        this.props.clearAccount();
      }
    );
  };

  handleMonthChange = e => {
    let userInput = e.target.value.toString();
    if (userInput.length <= 2) {
      this.setState({ month: userInput });
    }
    if (userInput.length === 2) {
      document.getElementById('1').nextElementSibling.focus();
    }
  };

  handleDayChange = e => {
    let userInput = e.target.value.toString();
    if (userInput.length <= 2) {
      this.setState({ day: userInput });
    }
    if (userInput.length === 2) {
      document.getElementById('2').nextElementSibling.focus();
    }
  };

  handleYearChange = e => {
    let userInput = e.target.value.toString();
    if (userInput.length <= 4) {
      this.setState({ year: userInput });
    }
    if (userInput.length === 4) {
      document.getElementById('email').focus();
    }
  };

  handleChange = event => {
    let currentState = this.state.data;

    currentState = {
      ...this.state.data,
      [event.target.id]: event.target.id !== 'phone' ? event.target.value : event.target.value.replace(/-/g, ''),
    };

    this.setState({
      data: currentState,
      phoneWithDashes: event.target.id === 'phone' ? event.target.value : this.state.phoneWithDashes,
    });
  };

  getValidationState(controlId) {
    if (getErrorForItem(this.state.errors, controlId).length > 0) return 'error';
    return null;
  }

  formatDate() {
    let currentState = this.state.data;
    const { day, month, year } = this.state;

    let formattedDate = [year, month, day].join('-');

    currentState = {
      ...this.state.data,
      dateOfBirth: formattedDate,
    };

    this.setState({
      data: currentState,
    });
  }

  handleSubmit = event => {
    event.preventDefault();
    const { data } = this.state;
    const dataToSubmit = JSON.parse(JSON.stringify(data));

    //Fix passing default date when CL policy
    if (this.props.policyInfo.policyType !== 'Personal') {
      dataToSubmit.dateOfBirth = '1970-01-01';
    } else if (this.props.policyInfo.policyType === 'Personal') {
      //Fix passing default customer or billing number when PL policy
      dataToSubmit.customerOrBillingNumber = '0000000000';
    }

    userDetailsSchema
      .validate({ ...dataToSubmit }, { abortEarly: false })
      .then(response => {
        console.log('success');
        this.setState(
          {
            errors: [],
            isLoading: true,
          },
          () => {
            console.log(dataToSubmit);
            this.props.registerAccount(dataToSubmit);
          }
        );
      })

      .catch(issues => {
        console.log('error');

        this.setState({
          errors: issues,
        });
      });
  };

  onShowPasswordToggleClicked = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  _showTermOfUse = () => {
    const { email, firstName, lastName, phone, customerOrBillingNumber } = this.state;
    localStorage.setItem(
      'InputFields',
      JSON.stringify({
        email,
        firstName,
        lastName,
        phone,
        customerOrBillingNumber,
      })
    );
    this.props.transition.router.stateService.go('termOfUse', {}, { location: false });
  };

  popoverHoverFocus = (
    <Popover id="popover-trigger-hover-focus" title="Password requirements">
      {parse(
        '<ul><li>One uppercase character</li> <li>One lowercase character</li> <li>One number</li> <li>One special character</li>  <li>Cannot contain your email</li>  <li>8 Characters minimum</li> </ul>'
      )}
    </Popover>
  );

  render() {
    const { show, isLoading, data, errors, showPassword, phoneWithDashes } = this.state;

    return (
      <Modal show={show} onHide={this.handleClose} backdrop="static" dialogClassName="relative_position">

        <Modal.Header closeButton={!isLoading}>
          <Modal.Title bsClass="modal-title font_weight_bold">Create Account</Modal.Title>
        </Modal.Header>

        {isLoading && <Loading show={isLoading} />}

        {!isLoading && (
          <Modal.Body style={{ margin: 10 }}>
            <p style={{ textAlign: 'center', margin: '0px 70px' }}>
              Already have an account?
              <Button
                style={{ margin: 0, padding: 0 }}
                bsStyle="link"
                onClick={() => {
                  this.props.transition.router.stateService.go('registrationScreen1');
                  $('.sign-in').click();
                }}
              >
                Log In
              </Button>
            </p>
            <p style={{ textAlign: 'center', margin: '0px 70px' }}>
              To create your West Bend Mutual Insurance online account, fill out the form below.
            </p>

            <form onSubmit={this.handleSubmit} style={{ marginTop: 30 }}>
              <Grid>
                <Row>
                  <Col md={6}>
                    <FormGroup controlId="firstName" validationState={this.getValidationState('firstName')}>
                      <ControlLabel>First name</ControlLabel>
                      <FormControl type="text" value={data.firstName} onChange={this.handleChange} autoComplete="off" />
                      {getErrorForItem(errors, 'firstName').length > 0 && (
                        <HelpBlock bsClass="text-danger">{getErrorForItem(errors, 'firstName')[0].message}</HelpBlock>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup controlId="lastName" validationState={this.getValidationState('lastName')}>
                      <ControlLabel>Last name</ControlLabel>
                      <FormControl type="text" value={data.lastName} onChange={this.handleChange} autoComplete="off" />
                      {getErrorForItem(errors, 'lastName').length > 0 && (
                        <HelpBlock bsClass="text-danger">{getErrorForItem(errors, 'lastName')[0].message}</HelpBlock>
                      )}
                    </FormGroup>
                  </Col>

                  {this.props.policyInfo.policyType === 'Personal' && (
                    <Col md={6}>
                      <FormGroup controlId="dateOfBirth" validationState={this.getValidationState('dateOfBirth')}>
                        <ControlLabel>Date of birth</ControlLabel>
                        <Row style={{ paddingLeft: '16px' }}>
                          <input
                            style={{ width: '55px', color: '555', marginRight: '6px' }}
                            required={'required'}
                            className={'form-control'}
                            id="dateOfBirth"
                            minLength={2}
                            maxLength={2}
                            type="text"
                            placeholder={'MM'}
                            value={this.state.month}
                            onChange={this.handleMonthChange}
                            onKeyPress={event => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            aria-label="dob-Month"
                            autoComplete="off"
                          />

                          <input
                            style={{ width: '55px', color: '555', marginRight: '6px' }}
                            required={'required'}
                            className={'form-control'}
                            id={2}
                            minLength={2}
                            maxLength={2}
                            type="text"
                            placeholder={'DD'}
                            value={this.state.day}
                            onChange={this.handleDayChange}
                            onKeyPress={event => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            aria-label="dob-Date"
                            autoComplete="off"
                          />

                          <input
                            style={{ width: '70px', color: '555' }}
                            required={'required'}
                            className={'form-control'}
                            minLength={4}
                            maxLength={4}
                            type="text"
                            placeholder={'YYYY'}
                            value={this.state.year}
                            onChange={this.handleYearChange}
                            onKeyPress={event => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            aria-label="dob-Year"
                            autoComplete="off"
                          />
                        </Row>

                        {getErrorForItem(errors, 'dateOfBirth').length > 0 && (
                          <HelpBlock bsClass="text-danger">
                            {getErrorForItem(errors, 'dateOfBirth')[0].message}
                          </HelpBlock>
                        )}
                      </FormGroup>
                    </Col>
                  )}

                  <Col md={6}>
                    <FormGroup controlId="email" validationState={this.getValidationState('email')}>
                      <ControlLabel>Email address</ControlLabel>
                      <FormControl autoComplete="off" type="text" value={data.email} onChange={this.handleChange} />
                      {getErrorForItem(errors, 'email').length > 0 && (
                        <HelpBlock bsClass="text-danger">{getErrorForItem(errors, 'email')[0].message}</HelpBlock>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup controlId="phone" validationState={this.getValidationState('phone')}>
                      <ControlLabel>Telephone number</ControlLabel>

                      <FormControl
                        componentClass={MaskedInput}
                        type="tel"
                        value={phoneWithDashes}
                        onChange={this.handleChange}
                        mask="111-111-1111"
                        autoComplete="off"
                      />

                      {getErrorForItem(errors, 'phone').length > 0 && (
                        <HelpBlock bsClass="text-danger">{getErrorForItem(errors, 'phone')[0].message}</HelpBlock>
                      )}
                    </FormGroup>
                  </Col>

                  {this.props.policyInfo.policyType !== 'Personal' && (
                    <Col md={6}>
                      <FormGroup
                        controlId="customerOrBillingNumber"
                        validationState={this.getValidationState('customerOrBillingNumber')}
                      >
                        <ControlLabel>
                          Customer or account number&nbsp;
                          <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement="top"
                            overlay={this.renderCustomerOrBillingTooltip}
                          >
                            <Glyphicon glyph="info-sign" />
                          </OverlayTrigger>
                        </ControlLabel>

                        <FormControl
                          autoComplete="off"
                          type="text"
                          value={data.customerOrBillingNumber}
                          onChange={this.handleChange}
                        />
                        {getErrorForItem(errors, 'customerOrBillingNumber').length > 0 && (
                          <HelpBlock bsClass="text-danger">
                            {getErrorForItem(errors, 'customerOrBillingNumber')[0].message}
                          </HelpBlock>
                        )}
                      </FormGroup>
                    </Col>
                  )}

                  <Col md={6}>
                    <FormGroup controlId="password" validationState={this.getValidationState('password')}>
                      <ControlLabel>Unique password</ControlLabel>

                      <InputGroup>
                        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={this.popoverHoverFocus}>
                          <FormControl
                            autoComplete="new-password"
                            type={showPassword ? 'text' : 'password'}
                            value={data.password}
                            onChange={this.handleChange}
                          />
                        </OverlayTrigger>

                        <InputGroup.Button>
                          <Button onClick={this.onShowPasswordToggleClicked}>
                            <Glyphicon glyph={showPassword ? 'eye-open' : 'eye-close'} />{' '}
                            {showPassword ? 'Show' : 'Hide'}
                          </Button>
                        </InputGroup.Button>
                      </InputGroup>
                      {getErrorForItem(errors, 'password').length > 0 && (
                        <HelpBlock bsClass="text-danger">{getErrorForItem(errors, 'password')[0].message}</HelpBlock>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </Grid>

              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Checkbox
                  checked={data.agreeToTerms}
                  onChange={() => {
                    this.setState({
                      ...this.state,
                      data: {
                        ...this.state.data,
                        agreeToTerms: !this.state.data.agreeToTerms,
                      },
                    });
                  }}
                >
                  I agree to West Bend’s
                  <a data-senna-off="true" href="https://insured.thesilverlining.com/terms-of-use" target="_blank">
                    {' '}
                    Terms of use{' '}
                  </a>
                  and{' '}
                  <a href="https://www.thesilverlining.com/privacy-policy" target="_blank">
                    Privacy Policy
                  </a>
                  .
                </Checkbox>
              </div>

              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  type="submit"
                  bsStyle="primary"
                  bsSize="large"
                  block
                  disabled={isLoading || !data.agreeToTerms}
                  style={{ width: 324 }}
                >
                  Create Account
                </Button>
              </div>
            </form>

            {this.props.response && this.props.response.code && <ErrorMessage {...this.props} />}
          </Modal.Body>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  account: state.account.registrationDetails,
  response: state.account.response,
  policyInfo: state.account.policyInfo,
});
const mapDispatchToProps = {
  registerAccount: accountOperations.registerUser,
  clearAccount: accountOperations.clearAccount,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterUserInfoScreen);
